export const SET_LEAGUE_TABLE_SEARCH_STATE = 'SET_LEAGUE_TABLE_SEARCH_STATE';
export const RESET_LEAGUE_TABLE_FILTERS_SEARCH = 'RESET_LEAGUE_TABLE_FILTERS_SEARCH';
